import React, {useEffect, useState, useRef } from 'react';
import { ManageBranchService } from '../api/services';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
const Recharge = () => {
  const [rechargeType, setRechargeType] = useState('SELF');
  const [amount, setAmount] = useState('');
  const [adminDdl, setAdminDdl] = useState([]);
  const [adminId, setAdminId] = useState('')
  const [IsLoading, setIsLoading] = useState(false);
  const [values, setValues] = useState({ Admin: '', organization: '', branch: '', branchUser: '',recharge:'' });
  const [errors, setErrors] = useState({});
  const [redvalue, setredvalue] = useState("");
  const [orgDdl, setOrgDdl] = useState([]);
  const [branchDdl, setBranchDdl] = useState([]);
  const [branchUser, setBranchUserDdl] =useState([]);
  const [selectedbranchUserId, setselectedbranchUserId] = useState([]);
  const adminVal = useRef('');
  const orgVal = useRef('');
  const branchVal = useRef('');
  const [rechargeAmount, setrechargeAmount] = useState([]);
  const navigate = useNavigate();
  const handleInput = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };


 function validate(values) {
  const errors = {};
  let isValid = true;

  if (rechargeType === "AGENT") {
    if (!values.Admin || values.Admin === "Select Admin") {
      errors.Admin = "Admin is required";
      isValid = false;
    }
    if (!values.organization || values.organization === "Select Organization") {
      errors.organization = "Organization is required";
      isValid = false;
    }
    if (!values.branch || values.branch === "Select Branch") {
      errors.branch = "Branch is required";
      isValid = false;
    }
    if (!values.branchUser || values.branchUser === "Select Branch User/Agent") {
      errors.branchUser = "Branch User is required";
      isValid = false;
    }
    if (!values.recharge || isNaN(values.recharge) || Number(values.recharge) <= 0) {
      errors.recharge = "Enter valid recharge amount";
      isValid = false;
    }
  }else if(rechargeType === "ADMIN"){
    if (adminId == "") {
      errors.Admin = "Admin is required";
      isValid = false;
    }
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      errors.recharge = "Enter valid recharge amount";
      isValid = false;
    }
  } else {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      errors.recharge = "Enter valid recharge amount";
      isValid = false;
    }
  }

  errors.validationFlag = isValid;  
  return errors;
}
const handleSubmit = (e) => {
  e.preventDefault();
  debugger
  const errorMsg = validate(values);
  setErrors(errorMsg);

  if (!errorMsg.validationFlag) {
    return; // Stop submission
  }

  const transactionId = generateTransactionId();
  const transferTo = rechargeType === "ADMIN"
    ? adminId
    : rechargeType === "AGENT"
      ? selectedbranchUserId
      :localStorage.getItem('admin_id');//11121 //localStorage.getItem('userid');

  const payLoad = {
    transaction_id: transactionId,
    transfer_to: transferTo,
    amount: rechargeType === "AGENT" ? values.recharge : amount,
    transaction_type: rechargeType
  };

  ManageBranchService.addAdminRecharge(payLoad)
    .then((res) => {
      if (res.data.code === "201") {
        alert(res.data.error_message);
      } else {
        alert(res.data.results);
      }
    })
    .catch((err) => {
      console.error('Failed to Recharge:', err);
    });
};

  // const handleSubmit = (e) => {
  //     e.preventDefault();
  //     const transactionId = generateTransactionId();
  //     const transferTo = rechargeType === "ADMIN" ? adminId : localStorage.getItem('userid');

  //     const payLoad = {
  //     transaction_id: transactionId,
  //     transfer_to: transferTo,
  //     amount: amount,
  //     transaction_type: rechargeType
  //     };

  //     ManageBranchService.addAdminRecharge(payLoad)
  //     .then((res) => {
  //     if (res.data.code === "201") {
  //     alert(res.data.error_message);
  //     } else {
  //     alert(res.data.results);
  //     alert("Recharge successfully");
  //     }
  //     })
  //     .catch((err) => {
  //     console.error('Failed to Recharge:', err);
  //     });
  // };
   useEffect(() => {
    debugger
    if(rechargeType === "ADMIN" || rechargeType === "AGENT"){
        fnAdminDdlLoad();
    }
    setErrors({});


   },[rechargeType])
   function fnAdminDdlLoad() {
    const BASE_URL = window.BASE_URL + '/get_admins';
    var config = {
      method: 'get',
      url: BASE_URL,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    };

    axios.request(config)
      .then(function (response) {
        setAdminDdl([]);

        if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
          setAdminDdl(response.data.results);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
 function generateTransactionId() {
  const timestamp = Date.now(); // milliseconds since epoch
  const random = Math.floor(Math.random() * 10000); // 4-digit random number
  return `TRANS_${timestamp}_${random}`;
}
 function fnAdminddlChange(event) {
    debugger
    adminVal.current = event.target.value;
    const adminId = adminVal.current;
    if (adminId != "" && adminId != "Select Admin") {
      var data = JSON.stringify({
        "admin_id": adminId,
      });
      const BASE_URL = window.BASE_URL + '/get_organizations';
      setIsLoading(true);
      var config = {
        method: 'post',
        url: BASE_URL,

        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
        data: data
      };

      axios.request(config)
        .then((response) => {

          setOrgDdl([]);
          if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
            setOrgDdl(response.data.results);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    else {
      setOrgDdl([]);
    }
  }

  function fnOrganizationChange(event) {
    orgVal.current = event.target.value;
    const orgId = orgVal.current;
    if (orgId != "" && orgId != "Select Organization") {
      var data = JSON.stringify({
        "organization_id": orgId,
      });
      const BASE_URL = window.BASE_URL + '/get_branches';
      setIsLoading(true);
      var config = {
        method: 'post',
        url: BASE_URL,

        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
        data: data
      };

      axios.request(config)
        .then((response) => {

          setBranchDdl([]);
          if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
            setBranchDdl(response.data.results);
           
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    else {
      setBranchDdl([]);
    }
  }
  function fnBranchChange(event) {
    debugger
    branchVal.current = event.target.value;
    getUsersByBranchId();
  }

  // get users data 
  const getUsersByBranchId=()=>{
    const payload = {
      organization_id :orgVal.current,
      branch_id: parseInt(branchVal.current)
    }
    setIsLoading(true);
    ManageBranchService.getUsersByBranchId(payload)
    .then((res)=>{
      if (res.data.code === 200) {
        setBranchUserDdl(res.data.results);
      } else {
        setBranchUserDdl([]);
      }
      setIsLoading(false);
    }).catch((err) => {

      console.error('Failed to fetch title:', err)
        setIsLoading(false);
    });
    
  };
 

return (
  <div className="container-fluid">
    {/* Loader */}
    <div className="loader" style={IsLoading ? {} : { display: 'none' }}>
      <div className="lds-spinner">
        <div></div><div></div><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div><div></div><div></div>
      </div>
    </div>
   <button
      className="btn btn-outline-secondary mb-3"
       onClick={() => navigate(-1)}>
        ← Back
    </button>
    <div className="super-admin-container form-outer shadow rounded">
      
    
      <div className="super-admin-header">
          
          <h1>Recharge</h1>
        </div>
      <form onSubmit={handleSubmit}>
        <div className="row">

          {/* Recharge Type */}
          <div className="col-md-4 col-12 mb-3">
            <label className="form-label">Recharge Type</label>
            <select
              className="form-select"
              value={rechargeType}
              onChange={(e) => setRechargeType(e.target.value)}
            >
              <option value="SELF">SELF</option>
              <option value="ADMIN">ADMIN</option>
              <option value="AGENT">AGENT</option>
            </select>
          </div>

          {/* Admin Dropdown (Only if ADMIN selected) */}
          {rechargeType === "ADMIN" && (
            <div className="col-md-4 col-12 mb-3">
              <label className="form-label">Select Admin</label>
              <select
                className="form-select"
                name="admin"
                onChange={(e) => setAdminId(e.target.value)}
              >
                <option>Select Admin</option>
                {adminDdl.map((p) => (
                  <option key={p.id} value={p.user_id}>{p.name}</option>
                ))}
              </select>
               { errors.Admin && (
              <span className="span-error">{errors.Admin}</span>
              )}
            </div>
          )}

          {/* AGENT-specific fields */}
          {rechargeType === "AGENT" && (
            <>
              <div className="col-md-4 col-12 mb-3">
                <label className="form-label">Select Admin</label>
                <select
                  className="form-select"
                  name="Admin"
                  onChange={(e) => {
                    handleInput(e);
                    fnAdminddlChange(e);
                  }}
                >
                  <option>Select Admin</option>
                  {adminDdl.map((p) => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
                {errors.Admin && <span className="span-error">{errors.Admin}</span>}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label className="form-label">Select Organization</label>
                <select
                  className="form-select"
                  name="organization"
                  onChange={(e) => {
                    handleInput(e);
                    fnOrganizationChange(e);
                  }}
                >
                  <option>Select Organization</option>
                  {orgDdl.map((p) => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
                {errors.organization && <span className="span-error">{errors.organization}</span>}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label className="form-label">Select Branch</label>
                <select
                  className="form-select"
                  name="branch"
                  onChange={(e) => {
                    handleInput(e);
                    fnBranchChange(e);
                  }}
                >
                  <option>Select Branch</option>
                  {branchDdl.map((p) => (
                    <option key={p.branch_id} value={p.branch_id}>{p.branch_name}</option>
                  ))}
                </select>
                {errors.branch && <span className="span-error">{errors.branch}</span>}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label className="form-label">Select Branch User/Agent</label>
                <select
                  className="form-select"
                  name="branchUser"
                  onChange={(e) => {
                    setselectedbranchUserId(e.target.value);
                    setValues(prev => ({ ...prev, branchUser: e.target.value }));
                  }}
                >
                  <option>Select Branch User/Agent</option>
                  {branchUser.map((p) => (
                    <option key={p.user_id} value={p.user_id}>{p.name}</option>
                  ))}
                </select>
                {errors.branchUser && <span className="span-error">{errors.branchUser}</span>}
              </div>
            </>
          )}

          {/* Amount (common for all types) */}
          <div className="col-md-4 col-12 mb-3">
            <label className="form-label">Recharge Amount</label>
            <input
              type="number"
              className="form-control"
              name={rechargeType === 'AGENT' ? "recharge" : ""}
              value={rechargeType === 'AGENT' ? values.recharge : amount}
              onChange={(e) => {
                rechargeType === 'AGENT'
                  ? handleInput(e)
                  : setAmount(e.target.value);
              }}
              placeholder="Enter amount"
            />
            { errors.recharge && (
              <span className="span-error">{errors.recharge}</span>
            )}
          </div>

          {/* Submit */}
         <div className="col-md-12 col-12 text-center my-3">
                <button type="submit" className="super-admin-button">Submit</button>
              </div>
        </div>
      </form>
    </div>
  </div>
);


};

export default Recharge;
